import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=50ce7e5c"
import script from "./Page.vue?vue&type=script&lang=ts"
export * from "./Page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports